// extracted by mini-css-extract-plugin
export default {"bg":"Footer_bg__2GYwl","footer-link":"Footer_footer-link__oW69o","desa":"Footer_desa__IHrRF","admin":"Footer_admin__5gQVq"};